import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { GisBoqWorkbenchItem, GisBoqWorkbenchService } from 'src/app/shared/services/gis-boq-workbench.service';

@Component({
  selector: 'app-gis-boq-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gis-boq-table.component.html',
  styleUrls: ['./gis-boq-table.component.css'],
})
export class GisBoqTableComponent implements OnInit, OnDestroy {
  @Input() tableExpanded = false;
  @Output() tableExpandedChange = new EventEmitter<boolean>();
  tilesHidden = false;
  private sub?: Subscription;
  private readonly tilesStorageKey = 'geo-boq-tiles-hidden';

  constructor(readonly wb: GisBoqWorkbenchService) {}

  ngOnInit(): void {
    this.sub = this.wb.state$.subscribe();
    try {
      this.tilesHidden = sessionStorage.getItem(this.tilesStorageKey) === '1';
    } catch {
      /* private mode */
    }
  }

  toggleTiles(): void {
    this.tilesHidden = !this.tilesHidden;
    try {
      sessionStorage.setItem(this.tilesStorageKey, this.tilesHidden ? '1' : '0');
    } catch {
      /* private mode */
    }
  }

  toggleExpanded(): void {
    this.tableExpandedChange.emit(!this.tableExpanded);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  tiles(): { key: string; label: string; value: number }[] {
    const t = this.wb.totals;
    return [
      { key: 'pavement', label: 'Pavement', value: t.pavement },
      { key: 'shoulder', label: 'Shoulder', value: t.shoulder },
      { key: 'structure', label: 'Structure', value: t.structure },
      { key: 'utility', label: 'Utility', value: t.utility },
      { key: 'safety', label: 'Safety', value: t.safety },
    ];
  }

  trackRow(_index: number, row: GisBoqWorkbenchItem): string {
    return row.item_code || row.item_description;
  }

  onRateChange(row: GisBoqWorkbenchItem, value: number | string): void {
    this.wb.updateRate(row, Number(value));
  }

  onCostChange(row: GisBoqWorkbenchItem, value: number | string): void {
    this.wb.updateCost(row, Number(value));
  }

  isEdited(row: GisBoqWorkbenchItem): boolean {
    return !!(row.item_code && this.wb.rateOverrides[row.item_code] != null);
  }
}
